import { combineReducers } from 'redux';
import oneToMany from './oneToMany';
import possibleValues, { getPossibleReferences as pvGetPossibleReferences, getPossibleReferenceValues as pvGetPossibleReferenceValues, } from './possibleValues';
export default combineReducers({
    oneToMany: oneToMany,
    possibleValues: possibleValues,
});
export var getPossibleReferenceValues = function (state, props) {
    return pvGetPossibleReferenceValues(state.possibleValues, props);
};
export var getPossibleReferences = pvGetPossibleReferences;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ra-core/esm/reducer/admin/references/index.js
// module id = 419
// module chunks = 0